import React from 'react';
import PropTypes from 'prop-types';
import MuiTooltip from '@material-ui/core/Tooltip';

import { componentIdStringGenerator } from '../../../helpers';

const Tooltip = (props) => {
  return (
    <MuiTooltip
      {...props}
      id={componentIdStringGenerator('Tooltip', props.id ? props.id : props.title ?? '')}
    />
  );
};

Tooltip.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
};

export default Tooltip;
